<template>
  <el-date-picker
    v-if="model"
    v-model="model[data.fieldId]"
    :type="data.setting.type"
    :prefix-icon="data.setting.prefixIcon"
    :format="data.setting.format"
    :placeholder="data.placeholder"
  />
  <el-date-picker
    v-else
    v-model="data.defaultValue"
    :type="data.setting.type"
    :prefix-icon="data.setting.prefixIcon"
    :format="data.setting.format"
    :placeholder="data.placeholder"
  />
</template>

<script>
export default {
  name: 'HDatePicker',
  props: {
    data: {
      type: Object,
      required: true
    },
    model: {
      type: [Object, null],
      default: null
    }
  }
}
</script>
